<template>
  <div class="adminmodelliadd">
    <b-container fluid>
      <b-row class="headerbox">
        <b-col>
          <h5>Carica un modello</h5>
        </b-col>
      </b-row>
      <br>
      <br>
      <b-row>
        <b-col cols="12">
          <file-pond ref="pond" label-idle="* Trascina o seleziona il modello da caricare" allow-multiple="false" max-files="1"/>
        </b-col>
      </b-row>
      <br>
      <br>
      <b-row>
        <b-col>
          <b-form-textarea class="slide-up" id="descrizione" v-model="formData.modello.descrizione" :state="state.descrizione" rows="3" max-rows="6" /><label for="descrizione">* Descrizione</label>
          <br>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col cols="12" md="9" offset-md="1">
          <p>* Campi obbligatori</p>
        </b-col>
        <b-col>        
          <b-button variant="success" size="lg" v-on:click="addModello()"><font-awesome-icon icon="plus-circle" /> Crea</b-button>
        </b-col>
      </b-row>
      <br>
    </b-container>
  </div>
</template>

<script>
import Vue from 'vue'
import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'

const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview)

export default {
  name: 'adminmodelliadd',
  data() {
    return {
      state: {
        descrizione: null
      },
      formData:{
        modello: {
          descrizione: ''
        }
      }
    }
  },
  components: {
      FilePond
  },
  methods: {
    addModello(){
      if(this.$refs.pond.getFiles().length > 0){
        var formSend = new FormData()
        formSend.append('modello', this.$refs.pond.getFiles()[0].file, this.$refs.pond.getFiles()[0].file.name)
        formSend.append('descrizione', this.formData.modello.descrizione)
        
        console.log(this.$refs.pond.getFiles()[0].file)
        
        console.log(formSend)
        Vue.http.post('admin/modello/add', formSend, {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            credentials : true
        }).then(response => {
          if(response.body.success){
            Vue.notify({
              group: 'global',
              title: 'Operazione riuscita!',
              text: 'Marca aggiunto con successo!',
              type: 'success'
            })
            this.$router.push('/admin/modelli')
          }else{
            for(var i=0; i<Object.keys(this.state).length; i++){
              this.state[Object.keys(this.state)[i]] = null
            }

            for(var i=0; i<response.body.inputError.length; i++){
              this.state[response.body.inputError[i]] = false
            }

            Vue.notify({
                group: 'global',
                title: 'Problemi durante la registrazione',
                text: response.body.msg,
                type: 'error'
            })
          }
        }, response => {})
      }else{
        Vue.notify({
            group: 'global',
            title: 'Problemi durante la registrazione',
            text: "Assicurati di aver selezionato correttamente un file!",
            type: 'error'
        })
      }
    }
  }
}
</script>

<style>
.adminmodelliadd #descrizione{
  text-indent: 120px;
  line-height: 1.8;
}
</style>